import type { ModuleSubCategory } from '@/gql/enums';
import type {
    ExternalModuleFieldsFragment,
    NutritionModuleFieldsFragment,
    ReportingModuleFieldsFragment,
    TrainingModuleFieldsFragment,
    AssessmentModuleFieldsFragment,
} from '@/gql/graphql';

export type AvailableModule =
    | AssessmentModuleFieldsFragment
    | TrainingModuleFieldsFragment
    | NutritionModuleFieldsFragment
    | ExternalModuleFieldsFragment
    | ReportingModuleFieldsFragment;

export const getModuleSubCategory = (m: AvailableModule): ModuleSubCategory | null => {
    switch (m.__typename) {
        case 'AssessmentModuleDefinition':
        case 'TrainingModuleDefinition':
        case 'ExternalModuleDefinition':
            return m.subCategory ?? null;
        default:
            return null;
    }
};
